<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'UserInfo',
});
</script>

<template>
  <div></div>
</template>

<style scoped></style>
